// extracted by mini-css-extract-plugin
export default {"container":"services_container__v0Mcq","container_small":"services_container_small__wzdvD","container-lg":"services_container-lg__uHhN7","main":"services_main__PbRcW"};